import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=3ebc351e&"
import script from "./Pagination.vue?vue&type=script&lang=ts&setup=true&"
export * from "./Pagination.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports